import type { RootState } from "~/redux/store";
import { SubstepType } from "~/Configurators/Linear/dtos";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/m3/Alert/Alert";

export function selectIsMachiningExtraSubstepInvalid(state: RootState) {
  return state.linearConfigurator.substeps[SubstepType.ShaftMachiningExtra]?.isInvalid ?? false;
}
export function selectIsMachiningSubstepInvalid(state: RootState) {
  return state.linearConfigurator.substeps[SubstepType.ShaftMachining]?.isInvalid ?? false;
}

export const ErrorMessage = ({
  className,
  variant = "select",
}: {
  className?: string;
  variant?: "select" | "input";
}) => {
  const { t } = useTranslation();
  return (
    <Alert className={className} severity="error">
      {t(variant === "select" ? "linear.step.select.option" : "linear.step.select.valid.value")}
    </Alert>
  );
};
